// Port of api/fuel/app/classes/insights/game/ratings.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'ratings',
    priority: 1,
    enabled: false,
    requires: ['init'],
    insight: false,
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        var user_id = owner.get_id()
        var game_id = parseInt(vars.id, 10)

        var limit = detail ? 100 : 5

        // All GG ratings for this game (no Booster in offline mode)
        var ratingsRaw = Util.queryFast(
            'SELECT r.user_id AS user_id, r.rating_value AS rating ' +
            'FROM rating r WHERE r.game_id = ' + game_id +
            ' ORDER BY r.rating_value DESC'
        )

        var total = ratingsRaw.length
        var users = []

        var sliced = ratingsRaw.slice(0, limit)
        for (var i = 0; i < sliced.length; i++) {
            var uid = parseInt(sliced[i].user_id, 10)
            users.push({
                id: uid,
                rating: parseFloat(sliced[i].rating)
            })
            this._references.users.push(uid)
        }

        // User's rating revision history
        var revisionsRaw = Util.queryFast(
            'SELECT l.log_date AS date, l.log_rating AS rating, l.log_previous AS previous ' +
            'FROM log_user_rating l WHERE l.game_id = ' + game_id + ' AND l.user_id = ' + user_id +
            ' AND l.log_initial_sync != 1 ORDER BY l.log_date ASC'
        )

        var revisions = []
        for (var ri = 0; ri < revisionsRaw.length; ri++) {
            revisions.push({
                date: parseInt(revisionsRaw[ri].date, 10),
                rating: parseFloat(revisionsRaw[ri].rating),
                previous: parseFloat(revisionsRaw[ri].previous)
            })
        }

        return {
            ratings: {
                users: users,
                usersTotal: total,
                revisions: revisions
            }
        }

    }
})
